import { render, staticRenderFns } from "./uf.vue?vue&type=template&id=6620169e"
import script from "./uf.js?vue&type=script&lang=js&external"
export * from "./uf.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports